
import PEComplianceLicenseNotFoundSvgComponent from '../../assets/svg-components/not-found/pe-compliance-license';
import './index.scss';

export default function PEComplianceLicenseNotfound() {
  return (
    <>
      <div className="new-not-found-wrap">
        <div className="new-not-found-wrap__details">
          {/* <img
            src="/images/page-not-found/pe-compliance-license.svg"
            className="not-found-image img-fluid not-found-image-pe-compliance-license"
          /> */}
          <div className="not-found-image img-fluid not-found-image-pe-compliance-license">
            <PEComplianceLicenseNotFoundSvgComponent />
          </div>
          <p className="no-data-found-text">No licenses found for selected timeframe or filters. Please change date or filter criteria to view information.</p>
        </div>
      </div>
    </>
  );
}
